import {PostLoginLoanApplicationFlowStep} from './post-login-loan-application-flow.step';
import {Injectable} from '@angular/core';
import {UserInteractor} from '../../interactors/user.interactor';
import {Keys, StorageService} from '../../service/storage.service';

@Injectable()
export class UploadDocumentsStep extends PostLoginLoanApplicationFlowStep {
    constructor(userInteractor: UserInteractor, private storageService: StorageService) {
        super(userInteractor);
    }

    description(): string {
        return 'To accelerate your loan approval';
    }

    displayName(): string {
        return 'Upload Documents';
    }

    async isStepComplete(): Promise<boolean> {
        return !!(this.storageService.getItem(Keys.IS_UPLOAD_DOCUMENT_COMPLETED) === 'true');
    }

    url(): string {
        return this.createBorrowerFlowUrl('upload-documents');
    }
}


